import { Action } from 'redux';

import { RootAdminUiState } from './RootAdminUIState';
import { isSetRootAdminUiStateAction } from './RootAdminUiStateActions';

export function rootAdminUiStateReducer(
  previousState: RootAdminUiState = 'bootstrap',
  action: Action = null
): RootAdminUiState {

  if(isSetRootAdminUiStateAction(action) && previousState !== action.rootAdminUiState) {
    return action.rootAdminUiState;
  }

  return previousState;
}
